import React, { useState } from "react";

import { styled } from "@mui/material";
import { Icon } from "@iconify/react";
import {
  CircularProgressbar,
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { Fade } from "react-reveal";
import {Tooltip,tooltipClasses} from '@mui/material';

import ProgressProvider from "./ProgressProvider";

const SkillContainer = styled("div")(({theme,dark}) => ({
  width: "100px",
  height: "100px",
  borderRadius: "100px",
  // backgroundColor: "#ffffffac",
  backgroundColor: dark?"#22262E": "#fff",
  boxShadow: "0px 8px 20px rgba(35, 35, 35, 0.1)",
  display: "grid",
  placeItems: "center",
  cursor: "pointer",
  margin: "15px 10px",
  transition: "all 0.3s ease-in",

  "& .logo-icon": {
    position: "relative",
  },
  "&:hover": {
    transform: "scale(1.05)",
  },
  [theme.breakpoints.down('md')]:{
    width:80,
    height:80
  }


}));


const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    padding:'10px 20px',
    fontSize: 11,
  },
}));

const SkillOverview = ({ value, skill,dark }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Fade top delay={1500}>
     <CustomTooltip title={skill?.name || 'REACT'} placement="top">
     <SkillContainer
        onMouseEnter={() => {
          setIsHovered(true);
        }}
        onMouseLeave={() => {
          setIsHovered(false);
        }}
        dark={dark}
      >
        {isHovered ? (
          <ProgressProvider valueStart={0} valueEnd={value}>
            {(val) => (
              <CircularProgressbarWithChildren
                value={val}
                text={null}
                strokeWidth={5}
                styles={buildStyles({
                  textColor: "#3957D2",
                  pathColor: "#21D4FD",
                  trailColor:  dark?"#22262E": "#fff",
                })}
              >
                <Icon
                  icon={skill?.iconName || "vscode-icons:file-type-reactjs"}
                  width={50}
                  height={50}
                  className="logo-icon"
                />
              </CircularProgressbarWithChildren>
            )}
          </ProgressProvider>
        ) : (
          <Icon
            icon={skill?.iconName || "vscode-icons:file-type-reactjs"}
            width={50}
            height={50}
            className="logo-icon"
          />
        )}
      </SkillContainer>
     </CustomTooltip>
    </Fade>
  );
};

export default SkillOverview;
